module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "box-layout-inner",
    class: {
      'alert-child': _vm.alert
    }
  }, [_c('div', {
    staticClass: "title-block-alt acc-child"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.full_name)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "course-blocks"
  }, [_c('div', {
    staticClass: "course-details"
  }, [_c('span', [_vm._v(_vm._s(_vm.locale.text_date_of_birth_prefix + _vm.date_of_birth))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.text_next_on_camp_prefix))]), _vm._v(" "), (_vm.participant.attending_camp.next.date != null) ? _c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.participant.attending_camp.next.date.toDate().toDateString())
    }
  }) : _c('b', [_vm._v(_vm._s(_vm.locale.text_no_future_bookings))])]), _vm._v(" "), _c('div', {
    staticClass: "meta-links"
  }, [_c('router-link', {
    attrs: {
      "id": "updateChild",
      "to": {
        name: 'account.children.update',
        params: {
          id: _vm.participant.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.button_update_child_details))])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31692e5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Children/ChildBlock.vue
// module id = 165
// module chunks = 0